import React from 'react';
import SectionHeading from '../../Common/SectionHeading';
import Link from 'next/link';

const CaseStudy = ({title=null}) => {
    const CaseStudyData = 
    [
        {
            icon: "fas fa-balance-scale-right",
            name: "Competitive Assessment",
            description: "A CDMO client based in Europe, involved DelveInsight to provide in-depth competitor assessment of companies active in the pharma CDMO area, in order to understand effective landscaping and conduct strategic decision-making for gaining competitive advantage. The client wanted to expand their geographical scope and improve their product portfolio, for which they also requested competitive benchmarking outcomes from DelveInsight.",
            redirectTo: "/case-study/cdmo-competitive-assessment"
        },
        {
            icon: "fas fa-arrow-trend-up",
            name: "Market Assessment",
            description: "A large Asian conglomerate was working to develop their asset portfolio in Cell Imaging and Analysis, and was interested to assess the market scenario of software based devices in the Cell Analysis and Cell Observation segment, such as HCS, Cell Analyzers, Flow Cytometers etc., to understand the past and forecasted market, to assess decision of possible market entry and potential future commercial success. The client requested evidence-based market estimation, segmented by type, end users, and application in US, EU, and some select APAC nations.",
            redirectTo: "/case-study/market-&-competitive-assessment"
        },
        {
            icon: "fas fa-magnifying-glass",
            name: "Competitive Intelligence",
            description: "One of the regular Europe-based clients wished to evaluate a long-term research partner who can timely deliver valuable competitive insights to support the clinical, commercial, and launch strategies of their novel class of oncology product targeting AML, Multiple myeloma, and ALL indications. The client wanted a detailed analysis of the competitive activity in the space and periodic assessment of the regulatory situation in several countries for the planned commercialization by the partner, with the foremost criteria put forward being timely delivery of the competitive activity.",
            redirectTo: "/case-study/hematological-malignancy-competitive-intelligence"
        }
    ]
    return (
        <>
            <div id="PrCaseStudy">
                <section className="w-11/12 xl:max-w-screen max-w-screen-2xl mx-auto lg:my-8 my-4">
                    {(title) &&
                        <SectionHeading title={title}  customClass="center"/>
                    }
                    <div className="grid grid-cols-12 gap-6">
                        {CaseStudyData?.map((card, index) => (
                            <div key={index} className="lg:col-span-4 md:col-span-6 col-span-12">
                                <div key={card.id} className="card border p-4">
                                    <div className="flex">
                                        <div className="icon-wrapper mr-3">
                                            <i className={card.icon}></i>
                                        </div>
                                        <div className="text-left">
                                            <h3 className="text-lg font-semibold mb-0">{card.name}</h3>
                                            <p className="mb-2 text-base line-clamp-4 mt-0">
                                                {card.description}
                                            </p>
                                            <Link href={process.env.APP_URL+card.redirectTo} className="learn-more-hvr text-[#1b5df3] text-sm">
                                                Learn More <span className="fa fa-angle-right"></span>
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </section>
            </div>
        </>
      );
}
export default CaseStudy;
